/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformSystemStatusDto } from '../../models/platform-system-status-dto';

export interface GetSystemstatus$Params {
}

export function getSystemstatus(http: HttpClient, rootUrl: string, params?: GetSystemstatus$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformSystemStatusDto>> {
  const rb = new RequestBuilder(rootUrl, getSystemstatus.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformSystemStatusDto>;
    })
  );
}

getSystemstatus.PATH = '/api/SystemStatus';
